import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LeadBankActions } from './lead-bank.actions';
import { LeadBankService } from './lead-bank.service';
import { catchError, map, mergeMap, of } from 'rxjs';

@Injectable()
export class LeadBankEffects {
  constructor(
    private actions$: Actions,
    private leadBankService: LeadBankService
  ) {}

  loadLeadBanks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LeadBankActions.loadLeadBanks),
      mergeMap(() =>
        this.leadBankService.getLeadBanks().pipe(
          map(leadBanks => LeadBankActions.loadLeadBanksSuccess({ leadBanks })),
          catchError(error =>
            of(LeadBankActions.loadLeadBanksFailure({ error }))
          )
        )
      )
    )
  );

  validateEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LeadBankActions.validateEmail),
      mergeMap(({ email }) =>
        this.leadBankService.validateEmail(email).pipe(
          map(result => LeadBankActions.validateEmailSuccess({ result })),
          catchError(error =>
            of(LeadBankActions.validateEmailFailure({ error }))
          )
        )
      )
    )
  );

  submitExternalInvest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LeadBankActions.submitExternalInvest),
      mergeMap(({ payload }) =>
        this.leadBankService.submitExternalInvest(payload).pipe(
          map(res =>
            LeadBankActions.submitExternalInvestSuccess({ payload: res })
          ),
          catchError(error =>
            of(LeadBankActions.submitExternalInvestFailure({ error }))
          )
        )
      )
    )
  );
}
